// dropdown: the shared SelectInput skin — popover listbox, keyboard
// navigation, a check on the chosen row. Discrete input — saves on change.

import React from "react";
import { Controller, useFormContext } from "react-hook-form";

import { FieldError, FieldHelper, FieldLabel } from "./chrome";
import SelectInput from "./SelectInput";
import { V2FieldProps } from "./types";

export default function DropdownField({ field, onCommit }: V2FieldProps) {
  const { control, trigger } = useFormContext();

  return (
    <Controller
      control={control}
      name={field.ref}
      rules={{ required: field.required ? "This is required" : false }}
      render={({ field: rhf, fieldState: { error } }) => (
        <div>
          <FieldLabel
            text={field.title}
            htmlFor={field.ref}
            optional={!field.required}
          />
          <SelectInput
            id={field.ref}
            ariaLabel={field.title}
            options={(field.choices ?? []).map((choice) => ({
              value: choice.ref,
              label: choice.label,
            }))}
            value={typeof rhf.value === "string" ? rhf.value : null}
            placeholder={field.placeholder}
            invalid={Boolean(error)}
            onChange={(value) => {
              rhf.onChange(value ?? undefined);
              // A dropdown never blurs naturally — clear a standing error now.
              void trigger(field.ref);
              onCommit();
            }}
            onBlur={rhf.onBlur}
          />
          <FieldHelper text={field.description} />
          <FieldError message={error?.message} />
        </div>
      )}
    />
  );
}
